export default __webpack_public_path__ + "static/media/C-Zijena.5ea802eb.jpg";